<template>
  <el-dialog
    title="编辑公式"
    :visible.sync="isShow"
    width="800px"
    :show-close="false"
    :close-on-click-modal="false"
    class="default-dialog report-dialog"
  >
    <el-form ref="form" :inline="true" :model="form">
      <el-form-item v-if="data.style != '2'" label="科目名称：">
        <el-select v-model="form.subjectId" size="mini" filterable placeholder="请选择">
          <el-option
            v-for="item in subjectData"
            :key="item.id"
            :label="item.labels"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else label="项目名称：">
        <el-select v-model="form.projectId" size="mini" filterable placeholder="请选择">
          <el-option
            v-for="item in options.project"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运算符号：">
        <el-select v-model="form.operationalSymbol" size="mini" style="width: 80px">
          <el-option
            v-for="item in options.symbol"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="data.style
			 != '2' && showRegulation" label="取数规则：" size="mini">
        <el-select v-model="form.ruleOfFetch" style="width: 100px">
          <el-option
            v-for="item in options.regulation"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" class="minButton" :disabled="isDisabled" @click="handleClickAdd">添加</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <public-table :table="tableData" @onHandleoperate="handleOperation"></public-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" class="minButton" @click="isShow = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import publicTable from "@/components/publicTable";

export default {
  props: {
    ruleOfFetch:String,
    dialogVisible: Boolean,
    showRegulation: Boolean,
    showPlace: {
      type: [Number,String],
      default: 1
    },
    data: {
      type: Object,
      default() {
        return {
          reportId: "",
          yearPeriods: "",
          style: "1"
        };
      }
    }
  },
  components: {
    publicTable
  },
  data() {
    return {
      form: {
        reportId: "", // 主id
        yearPeriods: "", // 年和期
        operationalSymbol: "+", // 运算符号
        ruleOfFetch: "余额", // 运算取值
        subjectId: "", // 科目id（如果传了资产负债id 就不能传科目id）
        projectId: "" // 资产负债id
      },
      options: {
        symbol: [
          {
            value: "+",
            label: "+"
          },
          {
            value: "-",
            label: "-"
          }
        ],
        regulation: [
          {
            label: "余额",
            value: "余额"
          },
          {
            label: "借方余额",
            value: "借方余额"
          },
          {
            label: "贷方余额",
            value: "贷方余额"
          },
          {
            label: "借方发生",
            value: "借方发生"
          },
          {
            label: "贷方发生",
            value: "贷方发生"
          },
          {
            label: "实际损益额",
            value: "实际损益额"
          }
         
        ],
        project: []
      },
      tableData: {
        Maxheight: 400, // 限定高度
        isNotSuspensionShow: true, // 不显示悬浮效果
        border: true, // 是否带有纵向边框
        stripe: true, // 是否带有斑马纹
        loading: false, // 是否显示加载动画
        hasSelect: false, // 是否显示多选
        hasOperation: true, // 是否有操作功能
        hasContextmenu: false, // 是否有右键功能
        hasShowSummary: false, // 是否显示合计行
        hasShowPagination: false, // 是否显示分页
        config: [
          {
            label: "科目",
            value: "name",
            show: "normal"
          },
          {
            label: "运算符号",
            value: "operationalSymbol",
            width: 80,
            show: "normal"
          },
          {
            label: "取数规则",
            value: "ruleOfFetchs",
            show: "normal"
          },
          {
            label: this.showPlace==2?"年初数":"本年累计金额",
            value: "beginYearNumber",
            show: "normal"
          },
          {
            label: this.showPlace==2?"期末数":"本期金额",
            value: "finalNumber",
            show: "normal"
          }
        ],
        data: [],
        operation: {
          label: "操作",
          value: "operation",
          width: 80,
          data: [
            {
              label: "删除",
              value: "delete"
            }
          ]
        },
        page: {
          pageNo: 1,
          pageSize: 20,
          count: 10
        },
        center: {
          textAlign: "center"
        }
      },
      isRefresh: false,
      isDisabled: false
    };
  },
  computed: {
    isShow: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      }
    },
    // 科目
    subjectData() {
      return this.$store.state.getSubjectId.AllSubjectList;
    }
  },
  methods: {
    // 查询所有科目
    getSubject() {
      this.$store.dispatch("getAllSubject");
    },
    // 获取算法表数据
    getData() {
      let params = {
        reportId: this.data.reportId,
        yearPeriods: this.data.yearPeriods,
        quarter: this.data.quarter
      };

      try {
        this.tableData.loading = true;
        this.$http
          .post("reportform/getReportCalculationformula", params)
          .then(res => {
            this.tableData.loading = false;
            if (res) {
              this.tableData.data = res.data.data;
              this.tableData.data.forEach(item => {
                if (item.ruleOfFetch == "1") {
                  item.ruleOfFetchs = "余额";
                }
                if (item.ruleOfFetch == "2") {
                  item.ruleOfFetchs = "借方发生";
                }
                if (item.ruleOfFetch == "3") {
                  item.ruleOfFetchs = "贷方发生";
                }
                if (item.ruleOfFetch == "4") {
                  item.ruleOfFetchs = "发生金额";
                }
                if (item.ruleOfFetch == "5") {
                  item.ruleOfFetchs = "实际损益额";
                }
                if (item.ruleOfFetch == "6") {
                  item.ruleOfFetchs = "初始余额";
                }
                if (item.ruleOfFetch == "9") {
                  item.ruleOfFetchs = "借方余额";
                }
                if (item.ruleOfFetch == "10") {
                  item.ruleOfFetchs = "贷方余额";
                }
                if (item.name == "合计") {
                  item.standard = true;
                }
              });
              console.log(this.tableData)
              this.form.ruleOfFetch = this.ruleOfFetch
              console.log(this.ruleOfFetch)
              
            }
          });
      } catch (e) {
        this.tableData.loading = false;
      }
    },
    // 查询资产负债表每一项style=2的子项目
    getProjectsData() {
      let params = {
        id: this.data.reportId
      };
      this.$http.post("reportform/getProjects", params).then(res => {
        if (res) {
          if (res.data.data.length) {
            this.options.project = res.data.data;

            this.$set(this.form, "projectId", res.data.data[0].id);
          }
        }
      });
    },
    // 添加算法表数据
    handleClickAdd() {
      const prevent = this.$getSessionStorage("superPreventOperation");
      if (prevent) {
        this.$store.commit("SUPERPREVENTFUNCTION", true);
        return;
      }
      let isAdd = true;

      switch (this.data.style) {
        case "1":
          isAdd = this.form.subjectId ? true : false;
          this.form.projectId = "";
          !isAdd && this.$notify.error("科目名称不能为空！");
          break;
        case "2":
          isAdd = this.form.projectId ? true : false;
          this.form.subjectId = "";
          !isAdd && this.$notify.error("项目名称不能为空！");
          break;
      }

      if (isAdd) {
        try {
          // if(!(this.data.style!= '2' && this.showRegulation)) {
          // 	this.form.ruleOfFetch = 5;
          // }else {
          // 	this.form.ruleOfFetch = "余额";
          // }
          this.isDisabled = true;
          this.tableData.loading = true;
          this.$http
            .post("reportform/saveReportCalculationformula", this.form)
            .then(res => {
              this.tableData.loading = false;
              this.isDisabled = false;
              if (res && res.data.code == "1") {
                this.tableData.data = res.data.data;
                this.$notify.success("添加成功！");
                this.isRefresh = true;
                this.tableData.data.forEach(item => {
                  if (item.ruleOfFetch == "1") {
                    item.ruleOfFetchs = "余额";
                  }
                  if (item.ruleOfFetch == "2") {
                    item.ruleOfFetchs = "借方发生";
                  }
                  if (item.ruleOfFetch == "3") {
                    item.ruleOfFetchs = "贷方发生";
                  }
                  if (item.ruleOfFetch == "4") {
                    item.ruleOfFetchs = "发生金额";
                  }
                  if (item.ruleOfFetch == "5") {
                    item.ruleOfFetchs = "实际损益额";
                  }
                  if (item.ruleOfFetch == "6") {
                    item.ruleOfFetchs = "初始余额";
                  }
                   if (item.ruleOfFetch == "9") {
                  item.ruleOfFetchs = "借方余额";
                }
                if (item.ruleOfFetch == "10") {
                  item.ruleOfFetchs = "贷方余额";
                }
                  if (item.name == "合计") {
                    item.standard = true;
                  }
                });
              }
            });
        } catch (e) {
          this.tableData.loading = false;
          this.isDisabled = false;
        }
      }
    },
    // 表格操作
    handleOperation({ methods, row }) {
      const prevent = this.$getSessionStorage("superPreventOperation");
      if (prevent) {
        this.$store.commit("SUPERPREVENTFUNCTION", true);
        return;
      }
      switch (methods) {
        case "delete":
          this.handleDelete(row);
          break;
      }
    },
    // 删除
    handleDelete(row) {
      let params = {
        reportCalculationformulaId: row.id,
        yearPeriods: this.form.yearPeriods
      };

      try {
        this.$confirm(`确定删除吗？`, "提示", {
          type: "warning",
          closeOnClickModal: false
        })
          .then(res => {
            try {
              this.tableData.loading = true;
              this.$http
                .post("reportform/delReportCalculationformula", params)
                .then(res => {
                  this.tableData.loading = false;
                  if (res) {
                    this.$notify.success("删除成功！");
                    this.isRefresh = true;
                    this.tableData.data = res.data.data;
                    this.tableData.data.forEach(item => {
                      if (item.ruleOfFetch == "1") {
                        item.ruleOfFetchs = "余额";
                      }
                      if (item.ruleOfFetch == "2") {
                        item.ruleOfFetchs = "借方发生";
                      }
                      if (item.ruleOfFetch == "3") {
                        item.ruleOfFetchs = "贷方发生";
                      }
                      if (item.ruleOfFetch == "4") {
                        item.ruleOfFetchs = "发生金额";
                      }
                      if (item.ruleOfFetch == "5") {
                        item.ruleOfFetchs = "实际损益额";
                      }
                      if (item.ruleOfFetch == "6") {
                        item.ruleOfFetchs = "初始余额";
                      }
                      if (item.ruleOfFetch == "9") {
                        item.ruleOfFetchs = "借方余额";
                      }
                      if (item.ruleOfFetch == "10") {
                          item.ruleOfFetchs = "贷方余额";
                       }
                      if (item.name == "合计") {
                        item.standard = true;
                      }
                    });
                  }
                });
            } catch (e) {
              this.tableData.loading = false;
            }
          })
          .catch(erro => {});
      } catch (e) {}
    }
  },

  watch: {
    dialogVisible(val) {
      if (val) {
        this.getSubject();

        this.form = Object.assign({}, this.form, this.data);
        this.isRefresh = false;
        this.$nextTick(() => {
          this.tableData.config.forEach(item => {
            if (item.value == "ruleOfFetch") {
              item.show =
                this.data.style === "1" && this.showRegulation
                  ? "normal"
                  : false;
            }

            // 当前页面是资产负债表时
            if (
              item.value == "finalNumber" ||
              item.value == "beginYearNumber"
            ) {
              item.show = this.$route.name != "ProfitSheets" ? "normal" : false;
            }

            // 当前页面是利润表时
            if (
              item.value == "countYearNumber" ||
              item.value == "periodsNumber"
            ) {
              item.show = this.$route.name == "ProfitSheets" ? "normal" : false;
            }
          });
          this.getData();
          this.getProjectsData();
        });
      }
    },
    isShow(val) {
      if (!val) {
        this.$emit("onRefresh", this.isRefresh);
      } else {
        this.form.subjectId = this.subjectData[0].id;
      }
    },
    data: {
      handler(newVal, oldVal) {
        this.form = Object.assign({}, this.form, {
          reportId: newVal.reportId,
          yearPeriods: newVal.yearPeriods
        });
      },
      deep: true
    }
  }
};
</script>
<style lang=less>
</style>



// WEBPACK FOOTER //
// src/components/dialog/balanceSheetDialog.vue